// @owners { team: patient-health }
import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { setTempPassword } from '~shared/actions/onboarding';
// eslint-disable-next-line import/no-deprecated
import { fetchAppDownloadLink } from '~shared/actions/users';
import getShowProgynySelfServiceForUser from '~shared/features/users/selectors/getShowProgynySelfServiceForUser';
import { useAnalytics } from '~shared/hooks/useAnalytics';
import { sendAnalyticsEvent } from '~shared/lib/analytics/src/actions';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { createEvent } from '~shared/lib/analytics/src/helper';
import { useDispatchShared, useSelectorShared } from '~shared/store';
import LandingPage from './LandingPage';

type Props = {
  readonly tempPassword: string;
};

const appDownloadClicked = false;
const LandingPageContainer = ({ tempPassword }: Props) => {
  const dispatch = useDispatchShared();
  const { trackPageView } = useAnalytics();
  const showProgyny = useSelectorShared(getShowProgynySelfServiceForUser);

  useEffect(() => {
    trackPageView({
      event: EVENTS.ONBOARDING__WEB_LANDING_PAGE_VIEWED,
      params: {
        is_progyny_rx_view: showProgyny,
      },
      additionalFields: {
        userIdentifier: tempPassword,
        userIdentifierType: 'temp_password',
      },
    });
  }, [trackPageView, tempPassword, showProgyny]);

  useEffect(() => {
    dispatch(setTempPassword(tempPassword));
  }, [tempPassword, dispatch]);

  useEffect(() => {
    // eslint-disable-next-line import/no-deprecated, promise/catch-or-return
    dispatch(fetchAppDownloadLink(tempPassword)).then((url: string) => {
      // Open the link immediately if the user wanted to open the link but it wasn't available yet
      // eslint-disable-next-line promise/always-return
      if (appDownloadClicked) {
        window.location.assign(url);
      }
    });
  }, [tempPassword, dispatch]);

  const handleOnboard = () => {
    dispatch(
      sendAnalyticsEvent(
        createEvent(
          EVENTS.WEB_LANDING_PAGE__GET_STARTED_TAPPED,
          {},
          {
            userIdentifier: tempPassword,
            userIdentifierType: 'temp_password',
          },
        ),
      ),
    );

    dispatch(push(`/onboard/verify/${tempPassword}`));
  };

  return <LandingPage handleOnboard={handleOnboard} />;
};

export default withRouter(LandingPageContainer);
